import { v4 as uuidv4 } from "uuid";

export const demoStudios = [
  {
    id: uuidv4(),
    avatar: "logo1.png",
    background: "team1.png",
    name: "Дизайн Студия Альфа",
    description: "Мы создаем визуальные истории, которые вдохновляют.",
    rating: 4.9,
    subscribers: 245,
  },
  {
    id: uuidv4(),
    avatar: "logo2.png",
    background: "team2.png",
    name: "Бета Арт Лаб",
    description: "Художественные решения для креативного будущего.",
    rating: 4.7,
    subscribers: 180,
  },
  {
    id: uuidv4(),
    avatar: "logo3.png",
    background: "team3.png",
    name: "Гамма Дизайн",
    description: "Дизайн в каждой детали.",
    rating: 4.8,
    subscribers: 312,
  },
];


export const articleTexts = [
  "Минимализм — это не про пустоту, а про осознанный выбор каждого элемента.",
  "Свет играет ключевую роль в восприятии пространства. Не бойтесь естественного освещения.",
  "Сочетание текстур — путь к созданию глубокого и уютного интерьера.",
  "Интерьер отражает личность. Сделайте пространство своим продолжением.",
  "Скандинавский стиль — простота, уют и функциональность в одном.",
  "Цвет акцента может изменить атмосферу всего помещения.",
  "Хорошо подобранная мебель — это не только комфорт, но и архитектура интерьера.",
  "Экологичность — тренд, который становится нормой. Выбирайте натуральные материалы.",
  "Зонирование помогает создать структуру и ритм в открытых пространствах.",
  "Винтаж и современность отлично сочетаются — главное, баланс.",
  "Стены — это холст. Используйте их смело: от краски до декоративных панелей.",
  "Интерьер — не только стиль, но и эмоции, которые он вызывает каждый день.",
  "Не бойтесь экспериментов. Яркий ковер может стать точкой притяжения.",
  "Функциональность и эстетика — равноправные составляющие хорошего дизайна.",
  "Правильный дизайн помогает чувствовать себя дома — везде.",
];


export const generateDemoArticles = (studioId) => {
  const images = [
    "design1.png", "design2.png", "design3.png", "design4.png", "design5.png",
    "design6.png", "design7.png", "design8.png", "design9.png", "design10.png", "design11.png"
  ];

  const articles = [];

  for (let i = 0; i < 5; i++) {
    const text = articleTexts[(Math.floor(Math.random() * articleTexts.length))];
    articles.push({
      id: uuidv4(),
      studioId,
      title: `Статья №${i + 1}`,
      text,
      image1: images[(i * 3) % images.length],
      image2: images[(i * 3 + 1) % images.length],
      image3: images[(i * 3 + 2) % images.length],
      likes: Math.floor(Math.random() * 100),
    });
  }

  return articles;
};

export const generateDemoPortfolios = (studioId) => {
  const images = ["design1.png", "design2.png", "design3.png", "design4.png", "design5.png", "design6.png", "design7.png", "design8.png", "design9.png", "design10.png", "design11.png"];
  const portfolios = [];

  for (let i = 0; i < 5; i++) {
    portfolios.push({
      id: uuidv4(),
      studioId,
      title: `Портфолио №${i + 1}`,
      image1: images[(i * 3) % images.length],
      image2: images[(i * 3 + 1) % images.length],
      image3: images[(i * 3 + 2) % images.length],
      likes: Math.floor(Math.random() * 100),
    });
  }

  return portfolios;
};
